import 'swiper/css';
import { EventText, useHeaderHeight, useScreenSize } from '../../layout';
import { Search } from '../../search';
import { useHeaderApi } from '../api';
import { SmartBanner } from './SmartBanner';
import { MainHeader } from './MainHeader';
import { Menu } from './menu/Menu';
import { Events } from '../../layout/components/events/Events';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface HeaderProps {
  events?: EventText[]; // 活動廣告
}

export function Header({ events = [], ...props }: HeaderProps) {
  useHeaderApi();
  useScreenSize();
  const headerRef = useHeaderHeight<HTMLElement>();

  return (
    <header
      ref={headerRef}
      className="tlw-sticky tlw-left-0 tlw-top-0 tlw-z-100"
    >
      <SmartBanner />

      <MainHeader />

      <Menu />

      <Search />

      {/* 走馬燈 */}
      {events.length > 0 && <Events events={events} />}
    </header>
  );
}
